import { render, staticRenderFns } from "./HelpLogo.vue?vue&type=template&id=6fd67abc&lang=pug&"
import script from "./HelpLogo.vue?vue&type=script&lang=js&"
export * from "./HelpLogo.vue?vue&type=script&lang=js&"
import style0 from "./HelpLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fd67abc')) {
      api.createRecord('6fd67abc', component.options)
    } else {
      api.reload('6fd67abc', component.options)
    }
    module.hot.accept("./HelpLogo.vue?vue&type=template&id=6fd67abc&lang=pug&", function () {
      api.rerender('6fd67abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HelpLogo.vue"
export default component.exports